import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

// US-6.3 GET /api/v1/Candidate/{id}/ComplianceScore ->
// ApiBaseResponse<ComplianceScoreResponse> i.e. { data: {...} }.
export const getComplianceScore = createAsyncThunk(
  "ComplianceScore/get",
  async (candidateId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.CANDIDATE.COMPLIANCE_SCORE}/${candidateId}/ComplianceScore`
      );
      return data?.data || null;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const complianceScoreSlice = createSlice({
  name: "complianceScore",
  initialState: {
    score: null,
    // which candidate the stored score belongs to, and which candidate the
    // newest request is for — used to discard stale/late responses so candidate
    // B never shows candidate A's score (the score lives in one shared store key).
    scoreCandidateId: null,
    requestedCandidateId: null,
  },
  reducers: {
    clearComplianceScore(state) {
      state.score = null;
      state.scoreCandidateId = null;
      state.requestedCandidateId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getComplianceScore.pending, (state, action) => {
        // a new candidate's score is being fetched — drop the previous one now
        state.requestedCandidateId = action.meta.arg;
        state.score = null;
        state.scoreCandidateId = null;
      })
      .addCase(getComplianceScore.fulfilled, (state, action) => {
        // ignore a response that finished after we already moved to another candidate
        if (action.meta.arg !== state.requestedCandidateId) return;
        state.score = action.payload;
        state.scoreCandidateId = action.meta.arg;
      });
  },
});

export const { clearComplianceScore } = complianceScoreSlice.actions;
export default complianceScoreSlice.reducer;
